import React, { useState, useEffect } from "react";
import { Button, Col, Container, FormGroup, Label, Row } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import {
  GetCompetencyCategoryRow,
  UpdateCompetencyCategoryData,
} from "../../services/CompetencyCategoryService";
import { GetVacancyTypeList } from "../../services/VacancyTypeServices";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { checkPermissionStatus } from "helpers/utils";
import api from "../../api";
import { MultiSelect } from "react-multi-select-component";

import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import { decryptDataFromArray } from "helpers/EncDec";
import { Trans, useTranslation } from "react-i18next";

function EditCompetencyCategory() {
  const { t } = useTranslation();
  const [formDataValues, setFormDataValues] = useState({});
  const [errors, setErrors] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [status, setStatus] = useState([
    { label: t(`mcq_manager.Active`), value: "1", id: "1" },
    { label: t(`mcq_manager.Inactive`), value: "0", id: "0" },
  ]);
  const [vacancyType, setVacancyType] = useState("");
  const { id } = useParams();
  const [Job, setJob] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [statePayload, setStatePayload] = useState({});
  const [testdata, setTestdata] = useState([]);
  const [lang_id, setLangId] = useState(() => {
    // Retrieve the lang_id from localStorage or set it to "1" if it doesn't exist or equals 1
    const storedLangId = localStorage.getItem("lang_id");
    return storedLangId && storedLangId !== "1" ? storedLangId : "1";
  });
  const history = useHistory();

    useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  const fetchAllTestRounds = async allJobValues => {
    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/admin/screening/fetch-alltestrounds`,
        { jobTitleIds: allJobValues },
      );

      const testdata = response.data.titlelist;
      let data = testdata?.map(item => ({
        id: item?.id,
        label: item?.name,
        value: item?.id,
      }));
      setTestdata(data);
    } catch (err) {}
  };

  const handleSelectAll = () => {
    setSelectedOptions(Job || []);
    const allJobValues = (Job || [])?.map(Job => Job?.id);
    setStatePayload(prevState => ({
      ...prevState,
      Job_id: allJobValues, // Update Job_id in statePayload with all Job values
    }));
  };
  const handleDeselectAll = () => {
    setSelectedOptions([]);
  };

  const handleChanges = selectedOptions => {
    setSelectedOptions(selectedOptions);
    console.log(selectedOptions, "selectedOptions");
    const allJobValues = selectedOptions?.map(Job => Job.id);
    fetchAllTestRounds(allJobValues);
    // console.log("allJobValues",allJobValues)
    setFormDataValues(prevState => ({
      ...prevState,
      Job_id: allJobValues, // Update Job_id in statePayload with all Job values
    }));
  };

  const extendedOptions = [
    // {
    //   value: "buttons",
    //   label: (
    //     <div className="d-flex gap-2">
    //       <button className="selectall-btn" onClick={handleSelectAll}>
    //         Select All
    //       </button>
    //       <button className="selectall-btn" onClick={handleDeselectAll}>
    //         Deselect All
    //       </button>
    //     </div>
    //   ),
    //   isDisabled: true,
    // },
    ...Job,
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GetCompetencyCategoryRow(id, lang_id);
        if (response.status === 200) {
          const { success, allcompetency } = response.data;
          setFormDataValues(allcompetency);
          // console.log("allcompe",allcompetency?.job_title);
          console.log(allcompetency?.joblist, "joblist");
          setSelectedOptions(allcompetency?.joblist || []);
          fetchAllTestRounds(allcompetency?.job_title);
          handleChangeVacancyTypeValuePopulate({
            value: allcompetency?.vacancy_type_id,
          });
          // setFormDataValues(prevState => ({
          //   ...prevState,
          //   Job_id: allcompetency?.job_title, // Update Job_id in statePayload with all Job values
          // }));
        } else {
          setErrors("No data available");
        }
      } catch (error) {
        setErrors("Error occurred while fetching data");
      }
    };

    fetchData();
  }, [id]);

  console.log(selectedOptions, "selectedOptionsstate");

  useEffect(() => {
    GetVacancyTypeList(lang_id)
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);
        if (responseData?.status) {
          let vacrr = responseData?.data?.map(item => ({
            label: item?.title,
            value: item?.id,
            id: item?.id,
          }));
          setVacancyType(vacrr);
        } else {
          toast.error("No data available");
        }
      })
      .catch(err => {
        toast.error("No data Available");
      });
  }, []);

  const handleStatusOptionSelection = id => {
    let record = status?.filter(item => item?.id == id);
    return record;
  };
  const handleChangeStatusValuePopulate = e => {
    setFormDataValues(prevState => ({
      ...prevState,
      status: e?.id,
    }));
  };

  const handleVacancyTypeOptionSelection = id => {
    // console.log('ww',vacancy_type);
    if (Array.isArray(vacancyType)) {
      return vacancyType?.find(item => item?.id === id);
    } else {
      console.warn("vacancyType is not an array:", vacancyType);
      return null;
    }
  };
  const handleChangeVacancyTypeValuePopulate = async e => {
    let vacancy_type_id = e?.value;
    api
      .get(
        `${process.env.REACT_APP_API_URL}/admin/job/fetch-jobbyvacancy/${vacancy_type_id}`
      )
      .then(response => {
        const alljobs = response.data.jobdata;
        console.log(alljobs, "alljobs");
        let data = alljobs?.map(item => ({
          id: item?.id,
          label: item?.title,
          value: item?.title,
        }));
        console.log(data, "jobdata");
        setJob(data);
      })
      .catch(err => console.log("Error:::", err));
    setFormDataValues(prevState => ({
      ...prevState,
      vacancy_type_id: vacancy_type_id,
    }));

    //handleDeselectAll();
  };

  /* Handle Change Event */
  const handleChange = e => {
    const { name, value } = e.target;
    setFormDataValues({
      ...formDataValues,
      [name]: value,
    });
  };

  // Validation logic for each field
  const validateForm = () => {
    let isValid = true;
    const newErrors = {};
    // console.log('vv',formDataValues);
    if (!formDataValues?.name) {
      newErrors.name = t(`mcq_manager.CompetencyCategoryRequired`);
      isValid = false;
    }
    if (!formDataValues?.vacancy_type_id) {
      newErrors.vacancy_type_id = t(`mcq_manager.VacancyTypeRequired`);
      isValid = false;
    }
    if (!formDataValues?.ques_count) {
      newErrors.ques_count = t(`mcq_manager.QuestionCountRequired`);
      isValid = false;
    }
    if (!formDataValues?.status) {
      newErrors.status = t(`mcq_manager.PleaseSelectAnOption`);
      isValid = false;
    }
    if (!formDataValues?.rounds) {
      newErrors.rounds = t(`mcq_manager.PleaseSelectAnOption`);
      isValid = false;
    }
    if (!parseInt(formDataValues?.duration)) {
      newErrors.duration = t(`mcq_manager.DurationRequired`);
      isValid = false;
    }
    if (selectedOptions?.length === 0) {
      newErrors.selectoption = t(`mcq_manager.PleaseSelectAnOption`);
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async e => {
    console.log(JSON.stringify(e), "competencyobject");
    if (validateForm()) {
      let data = {
        vacancy_type_id: e?.vacancy_type_id,
        name: e?.name,
        ques_count: e?.ques_count,
        status: e?.status,
        Job_id: e?.Job_id,
        duration: e?.duration,
        rounds: e?.rounds,
      };
      console.log(data, "data");
      UpdateCompetencyCategoryData(data, id, lang_id)
        .then(res => {
          if (res?.status === 200) {
            toast.success(res?.data?.message);
            history.push("/competency-category-list");
          } else {
            toast.error(res?.data?.message);
          }
        })
        .catch(err => {
          console.error("Error updating data:", err);
          setErrors("No data created.");
        });
    } else {
      console.error("Form has errors");
    }
  };

  if (!checkPermissionStatus("competency-category-list", "edit")) {
    return (
      <div className="page-content">
        <h4 className="text-center"> {t(`mcq_manager.Access Denied`)}</h4>
      </div>
    );
  }


  return (
    <>
      <div className="page-content">
        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center py-2 pt-0">
            <Col lg="6" md="6">
              <Link to="/competency-category-list">
                <h5 className="heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  {t(
                    `mcq_manager.Edit CONFIGURE COMPETENCY`
                  ).toLocaleLowerCase()}
                </h5>
              </Link>
            </Col>
            {/* <Col lg="6" md="6">
              <div className="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
                <Link
                  to="/competency-category-list"
                  className="btn btn-primary"
                >
                  Back To Listing
                </Link>
              </div>
            </Col> */}
          </Row>
        </div>

        <div className="outerTab-box-wrapper below-vacancy">
          <div className="form-details-section mt-3">
            <Container fluid>
              <Row>
                <AvForm
                  className="outer-repeater"
                  onValidSubmit={() => {
                    handleSubmit(formDataValues);
                  }}
                >
                  <div data-repeater-list="outer-group" className="outer">
                    <div data-repeater-item className="outer">
                      {successMessage && (
                        <div class="alert alert-success" role="alert">
                          {successMessage}
                        </div>
                      )}
                      {errorMessage && (
                        <div class="alert alert-danger" role="alert">
                          {errorMessage}
                        </div>
                      )}
                      <Row>
                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="category_name" // Ensure this matches the id of the form control
                              className="col-form-label"
                            >
                              {t(`mcq_manager.Competency`)}
                              <span className="text-danger">*</span>
                            </Label>
                            <div title={t(`mcq_manager.Competency`)}>
                              <AvField
                                type="text"
                                className="form-control"
                                id="category_name" // Match the id here
                                name="name"
                                placeholder={t(`mcq_manager.Competency Name`)}
                                value={formDataValues?.name || ""}
                                onChange={handleChange}
                              />
                            </div>
                            {errors?.name && (
                              <div className="error">{errors?.name}</div>
                            )}
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="vacancy_type_id"
                              className="col-form-label"
                            >
                              {t(`mcq_manager.Vacancy Type`)}
                              <span className="text-danger">*</span>
                            </Label>

                            <div
                              title={
                                formDataValues.vacancy_type_id &&
                                Array.isArray(vacancyType)
                                  ? vacancyType.find(
                                      elem =>
                                        elem.value ==
                                        formDataValues.vacancy_type_id
                                    )?.label
                                  : t("mcq_manager.Vacancy Type")
                              }
                            >
                              <Select
                                className="mb-1"
                                placeholder={t(`mcq_manager.Select Type`)}
                                id="vacancy_type_id"
                                name="vacancy_type_id"
                                // validate={{ required: { value: true } }}
                                options={vacancyType}
                                value={
                                  handleVacancyTypeOptionSelection(
                                    formDataValues?.vacancy_type_id
                                  ) || ""
                                }
                                onChange={e => {
                                  handleChangeVacancyTypeValuePopulate(e);
                                  handleDeselectAll();
                                }}
                                aria-label={t(`mcq_manager.Vacancy Type`)} // Adds an ARIA label for screen readers
                                tabIndex="0"
                              />
                            </div>
                            {errors?.vacancy_type_id && (
                              <div className="error">
                                {errors.vacancy_type_id}
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="vacancy_type_id"
                              className="col-form-label"
                            >
                              {t(`mcq_manager.Job Title`)}
                              <span className="text-danger">*</span>
                            </Label>
                            <div
                              className="selectoption"
                              title={
                                selectedOptions.length
                                  ? `${selectedOptions
                                      .map(
                                        option => option.label || option.name
                                      )
                                      .join(", ")}`
                                  : `${t("mcq_manager.Job Title")}`
                              }
                            >
                              {/* <Select
                                // isMulti
                                options={extendedOptions}
                                value={selectedOptions}
                                onChange={handleChanges}
                              />*/}
                              <MultiSelect
                                // shouldToggleOnHover={true}
                                options={extendedOptions}
                                value={selectedOptions}
                                onChange={handleChanges}
                                overrideStrings={{
                                  selectSomeItems: `Select Job Title`,
                                }}
                              />
                            </div>
                            {errors?.selectoption && (
                              <div className="error">
                                {errors?.selectoption}
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup className="mb-2">
                            <Label
                              htmlFor="vacancy_type_id"
                              className="col-form-label"
                            >
                              Rounds
                              <span className="text-danger">*</span>
                            </Label>
                            <select
                              id="rounds"
                              onChange={handleChange}
                              name="rounds"
                              className="form-control"
                              data-width="100%"
                              onMouseEnter={e => {
                                e.target.setAttribute(
                                  "title",
                                  e.target.options[e.target.selectedIndex].text
                                );
                              }}
                            >
                              <option selected disabled>
                                {t(`mcq_manager.Rounds`)}
                              </option>
                              {testdata?.map(el => {
                                return (
                                  <option
                                    selected={
                                      formDataValues?.rounds === el?.value
                                    }
                                    value={el?.value}
                                  >
                                    {el?.label}
                                  </option>
                                );
                              })}
                            </select>
                            {errors?.rounds && (
                              <div className="error">{errors?.rounds}</div>
                            )}
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="ques_count" // Ensure this matches the id of the form control
                              className="col-form-label"
                            >
                              {t(`mcq_manager.Question Count`)}
                              <span className="text-danger">*</span>
                            </Label>
                            <div title={t("mcq_manager.Question Count")}>
                              <AvField
                                type="number"
                                className="form-control"
                                id="ques_count" // Ensure this matches the htmlFor
                                name="ques_count"
                                placeholder={t(`mcq_manager.Question Count`)}
                                value={formDataValues?.ques_count || ""}
                                onChange={handleChange}
                              />
                            </div>
                            {errors?.ques_count && (
                              <div className="error">{errors?.ques_count}</div>
                            )}
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="duration" // Ensure this matches the id of the AvField
                              className="col-form-label"
                            >
                              {t(`mcq_manager.Duration(in minutes)`)}
                              <span className="text-danger">*</span>
                            </Label>
                            <div title={t(`mcq_manager.Duration(in minutes)`)}>
                              <AvField
                                type="number"
                                className="form-control"
                                id="duration" // The id here should match htmlFor in the Label
                                name="duration"
                                placeholder={t(
                                  `mcq_manager.Duration(in minutes)`
                                )} // Updated placeholder text
                                value={formDataValues?.duration || ""}
                                onChange={handleChange}
                              />
                            </div>
                            {errors?.duration && (
                              <div className="error">{errors?.duration}</div>
                            )}
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              className="col-form-label"
                              htmlFor="status_id"
                            >
                              {t(`mcq_manager.Status`)}
                              <span className="text-danger">*</span>
                            </Label>
                            <div
                              title={
                                formDataValues.status
                                  ? `${
                                      status.find(
                                        elem =>
                                          elem.value == formDataValues.status
                                      )?.label
                                    }`
                                  : `${t("mcq_manager.Select Status")}`
                              }
                            >
                              <Select
                                className="mb-1"
                                placeholder={t(`mcq_manager.Select Status`)}
                                id="status_id"
                                name="status"
                                validate={{ required: { value: true } }}
                                options={status}
                                value={
                                  handleStatusOptionSelection(
                                    formDataValues?.status
                                  ) || ""
                                }
                                onChange={e =>
                                  handleChangeStatusValuePopulate(e)
                                }
                                aria-label={t(`mcq_manager.Select Status`)} // Adds an ARIA label
                                tabIndex="0" // Explicitly specifies focusable tabindex
                              />
                            </div>
                            {errors?.status && (
                              <div className="error">{errors.status}</div>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                  </div>

                  <div className="cta gap-3 text-center d-flex justify-content-left mt-4 mb-2">
                    <Button
                      type="button"
                      className="btn btn-secondary"
                      onClick={e => {
                        e.preventDefault();
                        history.push("/competency-category-list");
                      }}
                    >
                      {" "}
                      {t(`mcq_manager.Cancel`)}
                    </Button>

                    <Button
                      type="submit"
                      color="success"
                      className="btn btn-primary"
                    >
                      {t(`mcq_manager.Update`)}
                    </Button>
                  </div>
                </AvForm>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditCompetencyCategory;
